/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import {
  Card,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import axios from "axios";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import React, { useEffect, useState } from "react";

import MDBox from "components/MDBox";
import Height from "components/height/height";
import PageTitle from "examples/PageTitle/PageTitle";
import { Link, useParams } from "react-router-dom";
import { appConstants } from "utils/appConstants";
import { getScreenRight } from "utils/generic";
import LoadingModal from "../../components/LoadingModel/loadingModal";

// @mui material components

// import filterFactory, { textFilter } from "react-bootstrap-table2-filter";

let fetchedRoles = [];
let searchParameter = "";

let fetchedUsers = [];
const SCREEN_NAME = "Standard Plan Features";
let SCREEN_RIGHT = "None";
let featureStatus = "Active";

function ViewSummary() {
  const { slotNo } = useParams();
  const { id } = useParams();

  console.log("slotNo", slotNo);
  const [customerReload, setCustomerReload] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const [deleteDialogeFlag, setDeleteDialogeFlag] = useState(false);
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [rowsSlot, setRowSlot] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [searchText, setSearchText] = useState("");

  const [values, setValues] = React.useState({
    featureType: "Count Based",
    featureName: "",
    featureSequence: 0,
    featureStatus: "Active",
    initialValue: "",
    finalValue: "",
    _id: "",
    defaultBusinessStandardPlanFeature: "",
    searchParameter: "",
    searchParameterList: [
      "featureName",
      "featureType",
      "featureSequenceString",
      "featureStatus",
    ],
  });

  const searchCustomerData = async () => {
    changeCustomerReload(!customerReload);
  };

  const changeCustomerReload = () => {
    setCustomerReload(!customerReload);
  };

  useEffect(() => {
    featureStatus = "Active";
    values.featureStatus = "Active";
    getRight();
  }, []);

  async function getRight() {
    SCREEN_RIGHT = await getScreenRight(SCREEN_NAME);
  }

  useEffect(() => {
    changeCustomerReload();
  }, [values.featureStatus]);

  useEffect(() => {
    searchParameter = values.searchParameter;
  }, [values.searchParameter]);
  let mandateFlag = false;

  useEffect(() => {
    fetchSlotDetailsBySlotNumber();
  }, []);

  const fetchSlotDetailsBySlotNumber = async () => {
    try {
      values.slot = parseInt(slotNo);
      await axios
        .post(
          appConstants.baseURL +
            "warehouseDashboard/fetchSlotDetailsBySlotNumber",
          { slotNumber: values.slot, loadPlanVehicleID: id }
        )
        .then((res) => {
          setLoading(false);
          console.log(
            "fetchSlotDetailsBySlotNumber(response)",
            res.data.Result_Output
          );
          setRowSlot(res.data.Result_Output);
          clearTimeout();
        })
        .catch((error) => {
          setLoading(false);
          console.log("Error in fetching user=" + JSON.stringify(error));
        });
    } catch (error) {
      console.log("Catch in fetchRoles:", error);
    }
  };

  const searchFilter = (rows, searchText) => {
    return rows.filter((row) =>
      Object.values(row).some(
        (value) =>
          typeof value === "string" &&
          value.toLowerCase().includes(searchText.toLowerCase())
      )
    );
  };

  const optionFilter = (rows, selectedStatus) => {
    return rows.filter((row) =>
      row.featureStatus.toLowerCase().includes(selectedStatus.toLowerCase())
    );
  };

  // const filteredData = searchFilter(rows, searchText);

  const filteredData = selectedStatus
    ? optionFilter(searchFilter(rows, searchText), selectedStatus)
    : searchFilter(rows, searchText);
  const selectedValue = (
    <FormControl fullWidth>
      <InputLabel id="demo-simple-select-label">Feature Status</InputLabel>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        style={{ minHeight: "3.1em" }}
        label="Feature Status"
        value={selectedStatus}
        onChange={(e) => setSelectedStatus(e.target.value)}
      >
        <MenuItem value="Active">Active</MenuItem>
        <MenuItem value="Inactive">Inactive</MenuItem>
      </Select>
    </FormControl>
  );

  return (
    <DashboardLayout>
      <DashboardNavbar screenName={"Standard Features"} />

      <Height val={30} />
      <Card>
        <PageTitle screenName={"View Order"} />
        <Grid container px={2}>
          <Grid
            item
            xs={12}
            md={3}
            lg={12}
            sx={{ display: "flex", justifyContent: "end" }}
          >
            <Link to={"/warehouseDashboard"}>
              <MDButton
                color="warning"
                onClick={() => {
                  sessionStorage.setItem("PARA_TABLE", "locked");
                }}
              >
                Back
              </MDButton>
            </Link>
          </Grid>
        </Grid>
        <MDBox mt={-3}>
          <DataTable
            style={{ marginTop: "0px" }}
            // loading={loading}
            // onReload={() => reloadData()}
            Header={false}
            screenName="View Orders"
            // addNew={true}
            // link="/standardFeatures/edit"
            canSearch={false}
            selectedValue={false}
            table={{
              // filterable: true,
              // filterMethod,
              rows: rowsSlot,
              // rows: [
              //   {
              //     orderNumber: "5",
              //     availVolume: "Jul 9,2023",
              //     balanceVol1: "",
              //     balanceVol2: "5",
              //     balanceVol3: "55",
              //     balanceVol4: "77",
              //     balanceVol5: "455",
              //     cargoType: 'Chiller (22)'
              //   },
              //   {
              //     orderNumber: "3",
              //     availVolume: "Jul 11,2023",
              //     balanceVol1: "",
              //     balanceVol2: "7",
              //     balanceVol3: "79",
              //     balanceVol4: "82",
              //     balanceVol5: "566",
              //     cargoType: 'General'

              //   },
              //   {
              //     orderNumber: "9",
              //     availVolume: "Jul 1,2023",
              //     balanceVol1: "",
              //     balanceVol2: "3",
              //     balanceVol3: "34",
              //     balanceVol4: "44",
              //     balanceVol5: "64",
              //     cargoType: 'General'

              //   },
              // ],

              columns: [
                {
                  Header: "Order Number",
                  accessor: "order.orderNumber",
                  style: { fontSize: "16px" },
                  align: "center",
                },
                // {
                //   Header: "Order Date",
                //   accessor: "availVolume",
                //   style: { fontSize: "16px" },
                //   align: "center",
                // },
                // {
                //   Header: "Order item",
                //   accessor: "orderItem",
                //   style: { fontSize: "16px" },
                // },
                // {
                //   Header: "Available Volume (mm3)",
                //   accessor: "itemCount",
                //   align: "center",
                //   style: { fontSize: "16px" },
                // },

                {
                  Header: "Item Description",
                  accessor: "orderItem.description",
                  align: "center",
                  style: { fontSize: "16px" },
                },
                {
                  Header: "Item Count",
                  accessor: "orderItem.numberOfItems",
                  align: "center",
                  style: { fontSize: "16px" },
                },
                {
                  Header: "Item Weight (kg)",
                  accessor: "orderItem.weightInKg",
                  align: "center",
                  style: { fontSize: "16px" },
                },
                {
                  Header: "Item Volume (mm3)",
                  accessor: "ss",
                  align: "center",
                  style: { fontSize: "16px" },
                },
                {
                  Header: "Cargo Type",
                  accessor: "orderItem.cargoType",
                  align: "center",
                  style: { fontSize: "16px" },
                },
              ],
            }}
            // rows={values.roles}

            isSorted={true}
            entriesPerPage={false}
            showTotalEntries={true}
            pagination={{ variant: "gradient" }}
            noEndBorder
          />{" "}
        </MDBox>
      </Card>

      <LoadingModal loading={loading} />
    </DashboardLayout>
  );

  // console.log("dfnjkdsnfjnsdjkf",)
}

export default ViewSummary;
